export const MAP_ZOOMS: [number, number, number, number] = [18, 13, 7.5, 2];

export const MAX_ZOOM_LEVEL = MAP_ZOOMS[0];
export const ZOOM_DISPLAY_DOTS = MAP_ZOOMS[1];
export const ZOOM_DISPLAY_WARNING = MAP_ZOOMS[2];
export const MIN_ZOOM_LEVEL = MAP_ZOOMS[3];
